import axios from 'axios'
import { apiObject } from './apiobject'

const auth = {
  login ({ username, password }) {
    return new Promise((resolve, reject) => {
      axios.post('/api-token-auth/', { username, password }, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  sessionLogin ({ username, password }) {
    return new Promise((resolve, reject) => {
      axios.post('/users/login/', { username, password }, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  sessionLogOut () {
    return new Promise((resolve, reject) => {
      axios.post('/users/logout/', { ignoreErrorHandle: true })
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  resetPw ({ email }) {
    return new Promise((resolve, reject) => {
      axios.post('/users/reset-password/', { email }, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  magicAuth ({ email, phone, from, timezone }) {
    return new Promise((resolve, reject) => {
      axios.post('/userforms/request-code/', { email, phone, from, timezone }, { ignoreErrorHandle: [400] })
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  verifyCode ({ code, email, phone }) {
    return new Promise((resolve, reject) => {
      axios.post('/userforms/verify-code/', { code, email, phone }, { ignoreErrorHandle: [400] })
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  verifyJWT ({ token }) {
    return new Promise((resolve, reject) => {
      axios.post('/userforms/verify-jwt/', { token }, { ignoreErrorHandle: [400] })
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  createSession ({ token }) {
    return new Promise((resolve, reject) => {
      axios.post('/userforms/create-session/', { token }, { ignoreErrorHandle: [400] })
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  getAppToken () {
    return new Promise((resolve, reject) => {
      axios.post('/api-get-token/')
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  }
}

const currentuser = {
  url: '/users/me/',
  get () {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  save (obj) {
    return new Promise((resolve, reject) => {
      let request = axios.post(this.url, obj, {ignoreErrorHandle: true})
      request.then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}

const organization = {
  url: '/users/org/',
  get () {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  save (obj) {
    return new Promise((resolve, reject) => {
      let request = axios.post(this.url, obj, {ignoreErrorHandle: true})
      request.then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  updateImage (fileUpload, type) {
    return axios.post(`${this.url}${type}/`,
      fileUpload,
      {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
  getSupport () {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}support/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getInfo () {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}info/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

const webhook = {
  ...apiObject,
  url: '/users/webhook/',
  rotatePsk (id) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${id}/rotate_psk/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const webhooklog = {
  ...apiObject,
  url: '/users/webhook-log/'
}

export default {
  auth,
  currentuser,
  organization,
  webhook,
  webhooklog
}
